import { Link, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import Loader from "../../../../components/loader/index.js";

import { createCustomerSocialReason } from "../../../../services/CatalogService";
import CustomerSocialReasonFields from "../../billing/customerSocialReason/formCustomerSocialReason/customerSocialReasonFields";

import {
  customerSocialReasonValidationSchema,
  customerSocialReasonInitialValues,
} from "../../billing/customerSocialReason/formCustomerSocialReason/customerSRFormConfig";

function NewCustomerCartaPorte({ onBack }) {
  const razonSocialVaroExpress = "VaroExpress";
  const razonSocialGruasVaro = "GruasVaro";
  const [registrarEnVaroExpress, setRegistrarEnVaroExpress] = useState(false);

  const navigate = useNavigate();
  const { Formik } = formik;
  function AutoValidateOnMount({ setTouched, validateForm }) {
    useEffect(() => {
      const allFieldsTouched = Object.keys(
        customerSocialReasonInitialValues
      ).reduce((acc, key) => ({ ...acc, [key]: true }), {});
      setTouched(allFieldsTouched, true);
      validateForm();
    }, [setTouched, validateForm]);

    return null;
  }
  return (
    <div>
      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Registro de nuevo cliente</PanelHeader>
            <PanelBody>
              <Formik
                validationSchema={customerSocialReasonValidationSchema}
                initialValues={customerSocialReasonInitialValues}
                onSubmit={async (values, { setSubmitting }) => {
                  try {
                    const payload = {
                      ...values,
                      fiscalRegimeId:
                        values.fiscalRegimeId?.id?.toString() || null,
                      cfdiId: values.cfdiId?.id?.toString() || null,
                      name: values.name ? values.name.trimEnd() : values.name,
                    };

                    //console.log(payload); // Verifica que los IDs son strings
                    const response = await createCustomerSocialReason(
                      payload,
                      razonSocialGruasVaro
                    );
                    console.log(
                      "Nuevo cliente registrado en VaroExpress:",
                      response
                    );

                    if (registrarEnVaroExpress) {
                      await createCustomerSocialReason(
                        payload,
                        razonSocialVaroExpress
                      );
                    }

                    Swal.fire({
                      title: "Registro exitoso",
                      text: "Se ha registrado el nuevo cliente",
                      icon: "success",
                      confirmButtonText: "Cerrar",
                    });

                    onBack(response);
                  } catch (err) {
                    Swal.fire({
                      title: "Ups!",
                      text: err.response?.data?.message || "Error al registrar",
                      icon: "error",
                      confirmButtonText: "Cerrar",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  setTouched,
                  validateForm,
                  isSubmitting,
                }) => (
                  <>
                    <Loader isLoading={isSubmitting} />
                    <Form noValidate onSubmit={handleSubmit}>
                      <AutoValidateOnMount
                        setTouched={setTouched}
                        validateForm={validateForm}
                      />
                      <CustomerSocialReasonFields
                        values={values}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={(field, value) => {
                          if (["fiscalRegimeId", "cfdiId"].includes(field)) {
                            if (!value || Object.keys(value).length === 0) {
                              values[field] = null;
                            } else {
                              values[field] = value;
                            }
                          } else {
                            values[field] = value;
                          }
                        }}
                      />

                      <Form.Group className="mb-3" controlId="switchGruasVaro">
                        <Form.Check
                          type="switch"
                          id="switch-gruas-varo"
                          label="Registrar cliente también en Varo Express"
                          checked={registrarEnVaroExpress}
                          onChange={(e) =>
                            setRegistrarEnVaroExpress(e.target.checked)
                          }
                        />
                      </Form.Group>

                      <Row className="mb-3">
                        <Col md="12" className="text-end">
                          <Button type="submit">Guardar Cliente</Button>{" "}
                          <Button variant="info" onClick={() => onBack(null)}>
                            Cancelar
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default NewCustomerCartaPorte;
